import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[tooltip]',
})
export class TooltipDirective {
  @Input() tooltip :string|null= ''; // The text for the tooltip to display
  @Input() delay = 200; // Optional delay input, in ms
  @Input() hideAfter = 5000; // Optional hide after input, in ms
  @Input() position = 'top';
  @Input() handler = 'conatiner';
  @Input() className = '';

  private myPopup: any;
  private timer: any;

  constructor(private el: ElementRef) {}

  ngOnDestroy(): void {
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    if(this.tooltip){
    this.timer = setTimeout(() => {
      this.createTooltipPopup();
    }, this.delay); 
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.timer) clearTimeout(this.timer);
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  private createTooltipPopup() {
    let popup = document.createElement('div');
    popup.innerHTML = `<div class="arrow" ></div> <div class="tooltip-inner"> ${this.tooltip} </div>`;
    popup.setAttribute('class', `custom-tooltip tooltip-${this.position} ${this.className}`);
    popup.setAttribute('role', 'tooltip');
    document.body.appendChild(popup);
    if (this.handler === 'pointer') {
      this.setPostionPointer(popup);
    } else {
      this.setPostionContainer(popup);
    }
    popup.style.zIndex='99999'
    this.myPopup = popup;
    setTimeout(() => {
      if (this.myPopup) this.myPopup.remove();
    }, this.hideAfter); // Remove tooltip after some time
  }

  private setPostionContainer(popup: HTMLDivElement) {
    const elDimensions = this.el.nativeElement.getBoundingClientRect();
    const offsetWidth = this.el.nativeElement.offsetWidth;
    const offsetHeight = this.el.nativeElement.offsetHeight;
    const tooltipWidth = popup.offsetWidth;
    const tooltipHeight = popup.offsetHeight;
    let x = 0;
    let y = 0;
    switch (this.position) {
      case 'bottom':
        x = elDimensions.left + (offsetWidth - tooltipWidth) / 2; // Get the middle of the element
        y = elDimensions.top + offsetHeight + 7; // Get the bottom of the element, plus a little extra
        break;
      case 'left':
        x = elDimensions.left - tooltipWidth - 7;
        y = elDimensions.top + (offsetHeight - tooltipHeight) / 2;
        break;
      case 'right':
        x = elDimensions.left + offsetWidth + 7;
        y = elDimensions.top + (offsetHeight - tooltipHeight) / 2;
        break;
      default:
        x = elDimensions.left + (offsetWidth - tooltipWidth) / 2; // Get the middle of the element
        y = elDimensions.top - tooltipHeight - 7;
    }
    popup.style.top = y.toString() + 'px';
    popup.style.left = x.toString() + 'px';
  }

  private setPostionPointer(popup: HTMLDivElement) {
    const elDimensions = this.el.nativeElement.getBoundingClientRect();
    const offsetWidth = this.el.nativeElement.offsetWidth;
    const offsetHeight = this.el.nativeElement.offsetHeight;
    const tooltipWidth = popup.offsetWidth;
    const tooltipHeight = popup.offsetHeight;
    let x = 0;
    let y = 0;
    switch (this.position) {
      case 'bottom':
        x = elDimensions.left + (offsetWidth - tooltipWidth) / 2; // Get the middle of the element
        y = elDimensions.top + offsetHeight + 7; // Get the bottom of the element, plus a little extra
        break;
      case 'left':
        x = elDimensions.left - tooltipWidth - 7;
        y = elDimensions.top + (offsetHeight - tooltipHeight) / 2;
        break;
      case 'right':
        x = elDimensions.left + offsetWidth + 7;
        y = elDimensions.top + (offsetHeight - tooltipHeight) / 2;
        break;
      default:
        x = elDimensions.x - tooltipWidth / 2; // Get the middle of the element
        y = elDimensions.y - tooltipHeight - 7;
    }
    popup.style.top = y.toString() + 'px';
    popup.style.left = x.toString() + 'px';
  }
}
